import { api } from '../index';
import { TAxiosResponse } from '../baseApiTypes';
import { ILanguagesResponse } from './types';

export const getLanguages = (): TAxiosResponse<ILanguagesResponse> =>
  api.get('/languages');

export const LanguagesApi = {
  getLanguages,
};
